import { apiFetch } from '../../apiFetch'

export const getAdminLocations = async (
  paginate = {
    page: 1,
    limit: 5
  }
) => {
  if (!paginate.limit) paginate.limit = 5
  if (!paginate.page) paginate.page = 1
  if (!paginate.q) paginate.q = ''
  return await apiFetch({
    path: `/admin/locations?q=${paginate.q}&limit=${paginate.limit}&offset=${
      (parseInt(paginate.page) - 1) * parseInt(paginate.limit)
    }`
  })
}

export const getAdminLocation = async (slug) => {
  return await apiFetch({
    path: `/admin/locations/${slug}`
  })
}

export const postAdminLocation = async (payload) => {
  const req = await apiFetch({
    method: 'POST',
    path: '/admin/locations/',
    payload
  })

  return await req
}
